import React from "react";
import { ProfileRow } from "../ProfileRow";
import { renderValue } from "../renderValueHelper";
import { useTranslation } from "@helpers/translate";
import "./index.sass";

export const EmailRow = ({ email }) => {
  const { __ } = useTranslation();

  return (
    <ProfileRow
      label={__("profile.email")}
      value={renderValue(email)}
    />
  );
};
